module.exports = __webpack_public_path__ + "static/media/bird.3975e173.jpg";